import React, {  } from "react";
import { ContentDropdown } from "@coverme/elements";
import { RetrocheckFacesheetPersonal } from "../Retrocheck/RetrocheckFacesheetPersonal";
import {RetrocheckFacesheetCoverage} from "../Retrocheck/RetrocheckFacesheetCoverage";
import {RetrocheckFacesheetPatientHistory} from "../Retrocheck/RetrocheckFacesheetPatientHistory"
import "./Retrocheck.scss";

export const RetrocheckFacesheetAccordion = ({patient,patientCoverages,patients}) => {
    return (
        <div className="facesheet-accordion">
            <div>
                <p className="facesheet-accordion__title">Patient Overview</p>
                <div className="facesheet-accordion__content">
                    <ContentDropdown title="Personal Information" estimatedHeight={1000000}>
                        <div>
                            <RetrocheckFacesheetPersonal
                                patientData={patient}
                            />
                        </div>
                    </ContentDropdown>
                    <ContentDropdown title="Coverage" estimatedHeight={1000000}>
                        <div>
                            <RetrocheckFacesheetCoverage
                                patientCoverages={patientCoverages}
                            />
                        </div>
                    </ContentDropdown>
                    <ContentDropdown title="History" estimatedHeight={1000000}>
                        <div>
                            <RetrocheckFacesheetPatientHistory
                                patients={patients}
                            />
                        </div>
                    </ContentDropdown>
                    
                </div>
            </div>
        </div>
    );
};
